import React, {  ReactNode } from "react";
import { createGenericModalContext } from "../../../../../components/BasicComponents/GenericModalContext";
import DialogDetalheOC from "./DialogDetalheOrdemCompra";

const { GenericModalProvider, useGenericModal } = createGenericModalContext<string>();

export const ModalDetalheOCProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
   return (
           <GenericModalProvider
               ModalComponent={DialogDetalheOC}
               urlParam="detalhe-ordem-compra"
           >
               {children}
           </GenericModalProvider>
       );
};

export const useModalDetalheOC = useGenericModal;